<template>
  <div class="container">
    <div class="app-aside">
      <div ref="container">
        <div class="app-aside-container">
          <a
            href="#ranking"
            class="app-aside__btn first"
            :class="{ active: currentView === 'ranking' || currentView === 'topic' }"
            @click="(e) => onClick('ranking', e)"
          >
            <span>大赛排行</span>
          </a>
          <a
            href="#reward"
            class="app-aside__btn"
            :class="{ active: currentView === 'reward' }"
            @click="(e) => onClick('reward', e)"
          >
            <span>大赛奖品</span>
          </a>
          <a
            href="#rules"
            class="app-aside__btn"
            :class="{ active: currentView === 'rules' }"
            @click="(e) => onClick('rules', e)"
          >
            <span>大赛规则</span>
          </a>
          <a
            href="#parsing"
            class="app-aside__btn"
            :class="{ active: currentView === 'parsing' }"
            @click="(e) => onClick('parsing', e)"
          >
            <span>大赛全解析</span>
          </a>
          <!-- <a
            href="#news"
            class="app-aside__btn"
            :class="{ active: currentView === 'news' }"
            @click="(e) => onClick('news', e)"
          >
            <span>大赛动态</span>
          </a> -->

          <img src="../../assets/qrcode.jpg" class="app-aside__qrcode" />
          <span class="app-aside__tip">有问题？扫码咨询</span>

          <img src="../../assets/top@2x.png" class="app-aside__top" @click="onScrollTop" />
        </div>

        <div class="app-aside-btns">     
          <BtnDownload
            class="app-aside-btns__btn btn__download"
            :diy="true"
            @click="goDownload"
          />
          
          <a
            target="_blank"
            href="https://crm2.qq.com/page/portalpage/wpa.php?uin=800185710&cref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa&ref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa%2Fstyle%26id%3Dwpa_setting_a01&pt=undefined&f=1&ty=1&ap=&as=&aty=0&a="
            class="app-aside-btns__btn"
          >
            <span>联系客服</span>
          </a>
        </div>
      </div>

      <div
        class="qa"
        :style="qaStyle"
        :class="{ 'is-expand': expand }"
        v-show="qaDisplay && false"
      >
        <span
          class="qa-icon"
          @click="triggerExpand"
        >
          <i class="iconfont icon-arrowdown"></i>
        </span>
        <div class="qa-hd"></div>
        <div class="qa-bd">
          <IscrollView v-if="iScrollLoaded" ref="iScroll">
            <div
              v-for="(item, i) in content"
              :key="i"
              class="qa-item"
              :id="'qa-item-' + i"
              :class="{ hover: currentHover === i }"
              @mouseenter="() => handleMouseEnter(i)"
              @mouseleave="handleMouseLeave"
            >
              <span class="q">Q：{{ item.Q }}</span>
              <span>A：{{ item.A }}</span>
            </div>
          </IscrollView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import device from '@jin10/utils/lib/device'
import jump from 'jump.js'
import BtnDownload from '../BtnDownload'

export default {
  components: {
    BtnDownload
  },
  props: {
    currentView: {
      type: String,
      default: 'ranking'
    }
  },
  data() {
    return {
      current: "ranking",
      links: [
        { href: '#ranking', title: '大赛排行' },
        { href: '#reward', title: '大赛奖品' },
        { href: '#rules', title: '大赛规则' },
        { href: '#news', title: '大赛动态' },
      ],
      content: [
        { Q: '上海黄金交易所是什么？', A: '国内合规合法化的黄金交易市场' },
        { Q: '交易侠开户收费吗？', A: '0门槛开户/开户无需收费' },
        { Q: '出入金到账时间多长？出入金需要几天到账？', A: '出入金0秒到账。资金安全有保障' },
        { Q: '有杠杆吗？', A: '黄金品种约7倍杠杆，白银约6倍杠杠。' },
        { Q: '交易侠可以交易什么品种？', A: '可交易上海黄金交易所的黄金、白银品种' },
        { Q: '交易侠实盘可以双向交易吗？', A: '上金所实盘品种是双向交易，买涨买跌皆可' }
      ],
      qaHeight: '',
      qaWidth: '',
      expand: true,
      iScrollLoaded: false,
      currentQ: 0,
      currentHover: '',
      qaDisplay: false
    }
  },
  computed: {
    qaStyle() {
      return {
        height: this.qaHeight + 'px',
        width: this.qaWidth + 'px'
      }
    }
  },
  mounted() {
    if (!device.isMobile) {
      this.qaHeight = 140
      this.qaWidth = 140

      this.qaDisplay = true

      // 设置qa样式
      // setTimeout(() => {
      //   this.iScrollLoaded = true
      //   this.qaWidth = this.$refs.container.offsetWidth * 2
      //   this.qaHeight = this.qaWidth * 450 / 360

      //   setTimeout(() => {
      //     this.$refs.iScroll.refresh()
      //   }, 500)
      // }, 700)

      // this.startTimer()

      // setTimeout(() => {
      //   if (this.expand) {
      //     this.triggerExpand()
      //   }
      // }, 10000)

      // window.addEventListener('resize', () => {
      //   if (this.expand) {
      //     this.zoomIn()
      //   } else {
      //     this.zoomOut()
      //   }
      // })
    }
  },
  methods: {
    handleMouseEnter (i) {
      clearInterval(this.timer)
      this.currentHover = i
    },
    handleMouseLeave () {
      this.startTimer()
      this.currentHover = ''
    },
    zoomOut () {
      this.qaWidth = this.$refs.container.offsetWidth
      this.qaHeight = document.documentElement.clientHeight - this.$refs.container.offsetHeight - this.$refs.container.offsetTop - 40

      clearTimeout(this.zoomTimer)
      this.zoomTimer = setTimeout(() => {
        this.$refs.iScroll.refresh()
      }, 500)
    },
    zoomIn () {
      this.qaWidth = this.$refs.container.offsetWidth * 2
      this.qaHeight = this.qaWidth * 450 / 360

      clearTimeout(this.zoomTimer)
      this.zoomTimer = setTimeout(() => {
        this.$refs.iScroll.refresh()
      }, 500)
    },
    triggerExpand () {
      this.expand = !this.expand

      if (this.expand) {
        this.zoomIn()
      } else {
        this.zoomOut()
      }
    },
    startTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.currentQ === this.content.length - 1) {
          this.currentQ = 0
        } else {
          this.currentQ += 1
        }
      }, 4000)
    },
    goDownload () {
      this.$bus.$emit('showDownload')
      jump('.app-topic__signin', {
        duration: 500
      })
    },
    onClick(hash, e) {
      e.preventDefault()
      jump('#' + hash, {
        duration: 500,
        offset: 0,
        callback: undefined
      })
    },
    onScrollTop() {
      jump(-window.scrollY, {
        duration: 400
      })
    }
  },
  watch: {
    currentQ: function() {
      const children = document.querySelectorAll('.qa-item')
      
      this.$refs.iScroll.scrollToElement(children[this.currentQ], 300)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";


.fadeInUp-leave-active {
  transition: all .5s ease-in-out;
}

// .fadeInUp-enter {
//   opacity: 0;
//   height: 0;
// }

.fadeInUp-leave-to {
  opacity: 0;
}

.container {
  position: fixed;
  left: 50%;
  top: 50%;
  height: 100%;
  z-index: 99;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.app-aside {
  width: percentage(142px / $baseWidth);
  padding-top: percentage(10px / 140px);
  height: 100%;
  min-width: 140px;
  position: absolute;
  z-index: 99;
  top: 50%;
  right: 0;
  transform: translate(100%, -50%);
  margin-right: percentage(-40px / 1200px);
  pointer-events: initial;

  &-btns__btn,
  &__btn {
    display: block;
    position: relative;

    span {
      position: absolute;
      @include middle();
      white-space: nowrap;
      color: $primaryColor;
    }
  }

  &-container {
    overflow: hidden;
    @include image-2x(
      "../../assets/aside-bg@1x.png",
      center top,
      no-repeat,
      100% 100%
    );
  }

  &__btn {
    margin: percentage(9px / 142px) auto 0;
    width: percentage(120px / 142px);
    padding-top: percentage(27px / 142px);
    @include image-2x(
      "../../assets/aside-btn-normal@1x.png",
      center top,
      no-repeat,
      100% auto
    );

    &.first {
      margin: percentage(84px / 142px) auto 0;
    }

    &.active {
      @include image-2x(
        "../../assets/aside-btn-active@1x.png",
        center top,
        no-repeat,
        100% auto
      );

      span {
        width: 100%;
        text-align: center;
        color: #ebc4bc;
      }
    }
  }

  &-btns {
    &__btn {
      width: 100%;
      padding-top: percentage(45px / 142px);
      margin-top: percentage(8px / 142px);

      @include image-2x(
        "../../assets/aside-btn-1@1x.png",
        center top,
        no-repeat,
        100% auto
      );

      &:hover {
        @include image-2x(
          "../../assets/aside-btn-1-active@1x.png",
          center top,
          no-repeat,
          100% auto
        );
      }

      &.btn__download {
        margin-top: percentage(16px / 142px);
        @include image-2x(
          "../../assets/aside-btn-2@1x.png",
          center top,
          no-repeat,
          100% auto
        );

        &:hover {
          @include image-2x(
            "../../assets/aside-btn-2-active@1x.png",
            center top,
            no-repeat,
            100% auto
          );
        }
      }

      span, /deep/span {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
      }
    }
  }

  &__qrcode {
    width: percentage(90px / 142px);
    margin: percentage(16px / 142px) auto 0;
    display: block;
    border: 1px solid #b77165;
  }

  &__tip {
    display: block;
    color: #9c6159;
    font-size: 12px;
    margin: percentage(6px / 142px);
    text-align: center;
  }

  &__top {
    display: block;
    margin: percentage(10px / 142px) auto 7px;
    width: percentage(112px / 142px);
    cursor: pointer;
  }
}

.qa {
  position: absolute;
  bottom: 20px;
  right: 0;
  margin: percentage(16px / 142px) auto 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  width: 140px;
  height: 140px;
  overflow: hidden;
  border-bottom: 1px solid #4b2c24;
  transition: all .3s;
  transition-timing-function: ease-in-out;
  pointer-events: initial;
  @include image-2x(
    "../../assets/qa-bg@1x.png",
    top,
    no-repeat,
    cover
  );

  &.is-expand {
    .qa-icon {
      transform: rotate(-90deg) translate(0, -40%); 
      border-radius: 0 0 9px 9px;

      .icon-arrowdown {
        bottom: -2px;
        left: 50%;
        transform: translate(-50%, 0) scale(0.8);
      }
    }
    .qa-hd {
      width: percentage(169px / 180px);
      padding-top: percentage((50px / 180px));
    }
  }

  .content-box {
    transition: .3s transform;
  }

  &-icon {
    width: 20px;
    height: 20px;
    color: #967370;
    position: absolute;
    top: 50%;
    z-index: 9;
    text-align: center;
    line-height: 20px;
    transform: rotate(90deg) translate(-40%, 40%);
    border-radius: 9px 9px 0 0;
    background: #3a292b;
    cursor: pointer;
    &:hover {
      .icon-arrowdown {
        color: #d8a8a0;
      }
    }

    .icon-arrowdown {
      position: absolute;
      left: 50%;
      bottom: 13px;
      transform: translate(-50%, 50%) scale(0.8);
      font-size: 11px;      
    }
  }

  &-hd {
    margin: 0 auto;
    width: 100%;
    padding-top: percentage(60px / 180px);
    @include image-2x(
      "../../assets/qa-hd@1x.png",
      center top,
      no-repeat,
      100% auto
    );
  }
  .qa-bd {
    flex: 1;
    position: relative;
    padding: 0 15px 8px;
    overflow: hidden;
  }
  .qa-item {
    margin-bottom: 15px;

    &:hover {
      span {
        font-size: 14px;
      }
    }
  }
  span {
    display: block;
    font-size: 13px;
    line-height: 18px;
    color: #D98676;
  }

  .q {
    color: #DDACA3;
  }
}

@include mobile {
  .app-aside {
    display: none
  }

  .container {
    display: none;
  }
}

@media screen and (max-width: 1280px) {
  .app-aside {
    min-width: 120px;

    &__btn {
      font-size: 12px;

      span {
        font-size: 12px;
      }

      &.first {
        margin: percentage(65px / 95px) auto 0;
      }
    }

    &-btns__btn {
      span, /deep/span {
        font-size: 12px;
      }
    }

    &__tip {
      font-size: 10px;
    }
  }
}


@media screen and (min-width: 2550px) {
  .container {
    max-width: 1664px;
  }

  .app-aside {
    min-width: 180px;

    &-btns {
    &__btn {
      span, /deep/span {
        font-size: 18px;
      }
    }
  }
  }
}
</style>
